export default "__VITE_ASSET__COpC4ADl__"